import React from 'react';

import BaseTable from 'components/common/baseTable/BaseTable';

export type Contact = { name: string; impressions: number; clicks: number };
interface ContactListsProps {
  data: {
    firstPartyContacts: Contact[];
    thirdPartyContacts: Contact[];
  };
}

const columnDefinitions = [
  {
    accessorKey: 'name' as keyof Contact,
    header: 'Name',
    minSize: 90,
    size: 250,
  },
  {
    accessorKey: 'clicks' as keyof Contact,
    header: 'Number of Clicks',
    size: 250,
  },
  {
    accessorKey: 'impressions' as keyof Contact,
    header: 'Number of Impressions',
    size: 250,
  },
];

const ContactLists = ({ data }: ContactListsProps) => {
  return (
    <div className='contact-lists'>
      <BaseTable
        className={'contact-list'}
        columnDefinitions={columnDefinitions}
        data={data.firstPartyContacts}
        title='First Party Contacts'
        initialPageSize={10}
      />
      <BaseTable
        className={'contact-list'}
        columnDefinitions={columnDefinitions}
        data={data.thirdPartyContacts}
        title='Third Party Contacts'
        initialPageSize={10}
      />
    </div>
  );
};

export default ContactLists;
